module.exports = "/images/veil-19.jpg";